import { useState } from 'react';
import { Select, Typography } from 'antd';
import moment, { Moment } from 'moment';
import { SelectBlueArrowIcon, DatePicker } from '@/components';
import { StatisticPeriodsEnum, useStatisticPeriodsOptions } from './hooks/useStatisticPeriodsOptions';
import classes from './ReportsStatisticDateFilters.module.scss';
import { RangePickerProps } from 'antd/lib/date-picker';

type PropsTypes = {
  startDate: Moment | null;
  endDate: Moment | null;
  setStartDate: (date: Moment | null) => void;
  setEndDate: (date: Moment | null) => void;
};

export const ReportsStatisticDateFilters = ({ startDate, endDate, setStartDate, setEndDate }: PropsTypes) => {
  const [selectedPeriod, setSelectedPeriod] = useState<string>(StatisticPeriodsEnum.YearToDate);
  const periodsOptions = useStatisticPeriodsOptions();

  const onChangePeriod = (period: string) => {
    if (period === StatisticPeriodsEnum.Custom) {
      setSelectedPeriod(StatisticPeriodsEnum.Custom);
      setStartDate(null);
      setEndDate(null);
      return;
    }
    setSelectedPeriod(period);
    setStartDate(moment(period));
    setEndDate(moment().startOf('month'));
  };

  const disabledDate: RangePickerProps['disabledDate'] = (current) => {
    return current > moment();
  };

  const onCalendarChange: RangePickerProps['onCalendarChange'] = (values, formatString, info) => {
    const [startDate, endDate] = values as Moment[];
    startDate && setStartDate(startDate.startOf('month'));
    endDate && setEndDate(endDate);
  };

  return (
    <div className={classes.filtersWrapper}>
      <div className={classes.filter}>
        <Typography.Text>Show stats for</Typography.Text>
        <Select
          options={periodsOptions}
          value={selectedPeriod}
          suffixIcon={<SelectBlueArrowIcon />}
          className={classes.periodSelect}
          onChange={onChangePeriod}
        />
      </div>
      {selectedPeriod === StatisticPeriodsEnum.Custom ? (
        <DatePicker.RangePicker
          picker="month"
          value={[startDate, endDate]}
          className={classes.datePicker}
          allowClear={false}
          disabledDate={disabledDate}
          onCalendarChange={onCalendarChange}
        />
      ) : null}
    </div>
  );
};
